import { Root } from '@radix-ui/react-dropdown-menu'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

export interface DropdownMenuProps extends ComponentPropsWithoutRef<
  typeof Root
> {
  defaultOpen?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  modal?: boolean // default true
  dir?: 'ltr' | 'rtl'
  children: ReactNode
}

export const DropdownMenu = Root
